/*=========================================================================================
  File Name: moduleCountryActions.js
  Description: Country Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
 fetchDataListItems({ commit }) {
      return axios.get("/api/Nationality/GetAll").then(res => {
        commit('SET_NATIONALITIES', res.data.Data);
      });
    },

  removeItem({ commit }, item) {
    
    return new Promise((resolve, reject) => {
      axios.delete(`API/Nationality/Delete/${item.Id}`, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
        .then((response) => {
          commit('REMOVE_ITEM', item.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
